import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getAllNotification = createAsyncThunk(
  "getAllNotification/getAllNotification",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("notification");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const getAllNotificationSlice = createSlice({
  name: "getAllNotification",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllNotification.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getAllNotificationSlice.reducer;
